/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultFlowInprogress } from '../../models/api-response-paged-result-flow-inprogress';
import { PagedRequestFlowInprogress } from '../../models/paged-request-flow-inprogress';

export interface SearchFlowInprogress$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestFlowInprogress
}

export function searchFlowInprogress(http: HttpClient, rootUrl: string, params: SearchFlowInprogress$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultFlowInprogress>> {
  const rb = new RequestBuilder(rootUrl, searchFlowInprogress.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultFlowInprogress>;
    })
  );
}

searchFlowInprogress.PATH = '/v1/api/ui/flows/search';
